import React from 'react'
import { Box, Button, Link, Typography, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { WarningIcon } from 'transfix-icons'

interface IQrErrorDisplayProps {
  regenerateQr: () => {}
}

export const useQrErrorDisplayStyles = makeStyles({
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '36px',
    marginBottom: '24px',
  },
  warningIconContainer: {
    width: '80px',
    height: '80px',
    backgroundColor: brandColors.coolGray1,
    borderRadius: '20px',
    marginBottom: '16px',
    padding: '16px',
  },
  subtitleOne: {
    fontSize: 18,
  },
})

export const QrErrorDisplay = ({ regenerateQr }: IQrErrorDisplayProps) => {
  const classes = useQrErrorDisplayStyles()

  return (
    <Box className={classes.errorContainer}>
      <Box className={classes.warningIconContainer}>
        <WarningIcon size='xxlarge' color='coolGray5' />
      </Box>
      <Box marginBottom='16px'>
        <Typography variant='subtitle1' className={classes.subtitleOne} align='center'>
          We couldn’t generate your code
        </Typography>
        <Box height='4px' />
        <Typography variant='body2' component='div' align='center'>
          Unable to load the code at this time. Retry or{' '}
          <Link href='tel:6469484480'>
            <b>call us</b>
          </Link>{' '}
          if the problem persists.
        </Typography>
      </Box>
      <Button color='secondary' fullWidth onClick={regenerateQr}>
        Retry
      </Button>
    </Box>
  )
}
